import * as React from "react";

import "./change-plan-modal.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load2}                  from "@Common/react/load2";
import {UseState}               from "@Common/react/use-state";
import {ModalService3}          from "@Common/ui-components/modal-service-3/modal-service-3";
import {LoadingSpinner}         from "@Common/ui-components/photo-dashboard/components/loading-spinner";
import {ModalLayout}            from "@Xpresso/routes/common/modal-layout/modal-layout";

import {ScheduledChangeContent} from "./scheduled-change-content/scheduled-change-content";
import {ReviewChangesContent}   from "./review-content/review-content";
import {InstantChangeContent}   from "./instant-change-content/instant-change-content";

export const ChangePlanModal = ({action, activeSubscription, selectedPlan, planDetails, next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["modalContent", ({}, next) => UseState({initValue: action, next})],
    ["modal", ({modalContent}, next) => ModalService3({
        xdQaName: "Change Plan Modal",
        rootNext,
        next,
        width: 400,
        onClose: () => modalContent.onChange(action),
    })],
    ["agent", ({session}, next) => next(session?.data?.agent)],
    ["details", ({apis, agent}, next) => Load2({
        fetch: () => apis.next.subscription.getPlanUpdateOptions({idAgent: agent?.idAgent}),
        next,
    })],
    ["ccInfo", ({apis, agent}, next) => Load2({
        fetch: () => apis.next.subscription.getActiveSubscriptionCreditCard({idAgent: agent?.idAgent}),
        next,
    })],
    ({modal, modalContent, details, ccInfo}) => ModalLayout({
        content: details.loading || ccInfo.loading ? (
            LoadingContent()
        ) : modalContent.value === Actions.INSTANT ? (
            InstantChangeContent({modalContent, activeSubscription, selectedDetails: GetSelectedPlanDetails({details, frequency: planDetails.periodMonths, selectedPlan}), ccInfo})
        ) : modalContent.value === Actions.SCHEDULED ? (
            ScheduledChangeContent({modalContent, activeSubscription, selectedDetails: GetSelectedPlanDetails({details, frequency: planDetails.periodMonths, selectedPlan}), ccInfo})
        ) : (
            ReviewChangesContent({modal, activeSubscription, selectedDetails: GetSelectedPlanDetails({details, frequency: planDetails.periodMonths, selectedPlan}), ccInfo})
        )
    })
);

const Actions = {
    INSTANT: 'instant',
    SCHEDULED: 'scheduled',
    REVIEW: 'review'
};

const LoadingContent = () => (
    <div className="plan-loading-content-9s8d" xd-qa-type="label" xd-qa-name="Loading">
        <div className="content-container">
            <LoadingSpinner text="Loading Plan Details..."/>
        </div>
    </div>
)

const GetSelectedPlanDetails = ({details, frequency, selectedPlan}) => {
    return details?.value && details?.value.find((subscription) => {
        return (
          subscription.pricePoint.periodMonths === frequency
        );
    });
}